module.exports = __webpack_public_path__ + "static/media/insideUSA.565c806e.svg";